module.exports = __webpack_public_path__ + "media/erft.a24ac048.mp4";